import { Component, Input, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'ci-sub-header',
  templateUrl: './sub-header.component.html',
  styleUrls: ['./sub-header.component.scss'],
  standalone: false
})
export class SubHeaderComponent {
  private router = inject(Router);

  @Input() title: string = '';

  openUploadPage() {
    this.router.navigate(['']);
  }

  openRepublishPage() {
    this.router.navigate(['republish']);
  }

  openSettingsPage() {
    this.router.navigate(['settings']);
  }

  openOrgManagementPage() {
    this.router.navigate(['organisation-management']);
  }
}
